<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
	<div class="cards-holder devices-tab {{ sectionclass }}">
		<div class="card card2 mRight" id="display-creative-v3-chart-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div *ngIf="!hasData">
				<img [src]="placeholderimage" class="no-creative-data" />
			</div>

			<div [hidden]="!hasData">
				<div class="c-portlet__header">
					<div class="o-stack__cell">
						<h5 class="creative-charts-header creative-charts-header-with-download">{{ sectiontitle }}</h5>
						<span class="datatable-icon">
							<a
								href="javascript:void(0)"
								class="datatable_download_icon"
								(click)="downloadCSV()"
								target="_blank"
								*ngIf="downloadConfiguration.enableDownload"
							>
								<i class="fa fa-download" aria-hidden="true"></i>
							</a>
						</span>
					</div>
				</div>
				<div class="performance-graph-area" #bubblechartcontainer>
					<div class="legend-area">
						Show data by
						<select (change)="processSelectedLegendItem($event.target.value)">
							<option *ngFor="let legendItem of legend" value="{{ legendItem.value }}">
								{{ legendItem.displayName }}
							</option>
						</select>
					</div>
					<app-creative-performance-graph
						[sectiontitle]="sectiontitle"
						[legendData]="legend"
						[chartType]="'areaspline'"
						[seriesName]="selectedLegendName"
						[graphData]="graphData"
						[customLegendData]="customLegendData"
						[enableCustomLegend]="true"
						[legendDisabled]="true"
						[name]="'creative_' + key"
						(legendSelected)="processSelectedLegendItem($event)"
						(mouseOutChart)="chartHover($event)"
						(mouseOverChart)="chartHover($event)"
						[svgHeight]="svgHeight"
						[ticksRotation]="'0'"
						[markerEnabled]="true"
						[showalldatesdata]="showalldatesdata"
						[findRVersion]="findRVersion"
					></app-creative-performance-graph>
				</div>
			</div>
		</div>
		<div class="card card1 mLeft devices-carousel creative-performance-stats display-creative-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div class="height-100p" *ngIf="hasData">
				<ngu-carousel
					#carousel
					[inputs]="carouselOne"
					(onMove)="onmoveFn($event)"
					(initData)="initDataFn($event)"
					[dataSource]="sortedCreatives"
					class="height-100p"
				>
					<ngu-tile *nguCarouselDef="let creative" NguCarouselItem>
						<div class="r4-stats-container">
							<div class="stats-container">
								<div class="title add-color" *ngIf="creative">
									<h5>
										{{ creative.creativeName }}
									</h5>
									<div>Showing creative {{ activeSlide + 1 }}/{{ sortedCreatives.length }}</div>
									<div class="tooltip">{{ creative.creativeName }}</div>
								</div>
								<div class="y-scroll-area" *ngIf="creative">
									<div
										*ngIf="
											isSocial &&
											creative.isIframeExpired == true &&
											creative?.snapshotImage &&
											!creative?.creativeThumbnail
										"
										class="creative-thumbnail"
									>
										<img
											[src]="creative?.snapshotImage"
											class="card-long-img"
											(click)="openModal('geofence-creative-v4', creative)"
											[ngClass]="{
												c300x600: creative.snapshotImage?.includes('300x600'),
												c728x90: creative.snapshotImage?.includes('728x90'),
												c160x600: creative.snapshotImage?.includes('160x600'),
												c320x50:
													creative.snapshotImage?.includes('320x50') || creative.snapshotImage?.includes('300x50'),
												c468x60: creative.snapshotImage?.includes('468x60')
											}"
										/>
									</div>
									<div *ngIf="isSocial && creative?.creativeThumbnail" class="creative-thumbnail">
										<img
											[src]="creative?.creativeThumbnail"
											class="card-long-img"
											(click)="openModal('geofence-creative-v4', creative)"
											[ngClass]="{
												c300x600: creative.creativeThumbnail?.includes('300x600'),
												c728x90: creative.creativeThumbnail?.includes('728x90'),
												c160x600: creative.creativeThumbnail?.includes('160x600'),
												c320x50:
													creative.creativeThumbnail?.includes('320x50') ||
													creative.creativeThumbnail?.includes('300x50'),
												c468x60: creative.creativeThumbnail?.includes('468x60')
											}"
										/>
									</div>
									<div
										*ngIf="
											(isSocial &&
												creative.isIframeExpired == true &&
												!creative?.snapshotImage &&
												!creative?.creativeThumbnail) ||
											(creative.iframeUrl == null && !creative?.creativeThumbnail)
										"
										class="creative-thumbnail"
									>
										<img
											src="../../../../../../assets/images/no-creative-preview-r2.png"
											class="card-long-img"
											(click)="openModal('geofence-creative-v4', creative)"
											[ngClass]="{
												c300x600: creative.creativeThumbnail?.includes('300x600'),
												c728x90: creative.creativeThumbnail?.includes('728x90'),
												c160x600: creative.creativeThumbnail?.includes('160x600'),
												c320x50:
													creative.creativeThumbnail?.includes('320x50') ||
													creative.creativeThumbnail?.includes('300x50'),
												c468x60: creative.creativeThumbnail?.includes('468x60')
											}"
										/>
									</div>
									<div
										*ngIf="!isSocial && !creative.isVideoCreative && !creative.adHeadline"
										class="creative-thumbnail"
									>
										<img
											[src]="creative?.creativeThumbnail"
											class="card-long-img"
											(click)="openModal('geofence-creative-v4', creative)"
											[ngClass]="{
												c300x600: creative.creativeThumbnail?.includes('300x600'),
												c728x90: creative.creativeThumbnail?.includes('728x90'),
												c160x600: creative.creativeThumbnail?.includes('160x600'),
												c320x50:
													creative.creativeThumbnail?.includes('320x50') ||
													creative.creativeThumbnail?.includes('300x50'),
												c468x60: creative.creativeThumbnail?.includes('468x60')
											}"
										/>
									</div>
									<div class="display-stats-container">
										<ul class="creative-stats display-stats">
											<li>
												<h5 class="stats">{{ creative.impressions | number }}</h5>
												<span class="stats-label">IMPRESSIONS</span>
											</li>
										</ul>
										<ul class="creative-stats display-stats">
											<li class="">
												<h5 class="stats">{{ creative.clicks | number }}</h5>
												<span class="stats-label">CLICKS</span>
											</li>
											<li>
												<h5 class="stats">{{ creative.clickRate | number : '1.2-2' }}%</h5>
												<span class="stats-label">CLICK RATE</span>
											</li>

											<div *ngIf="isSocial && creative.isVideoCreative">
												<li>
													<h5 class="stats">{{ creative.percentValue100 | number }}</h5>
													<span class="stats-label">COMPLETIONS</span>
												</li>
												<li>
													<h5 class="stats">{{ creative.percentRate100 | number : '1.2-2' }}%</h5>
													<span class="stats-label">COMPLETION RATE</span>
												</li>
											</div>
										</ul>

										<ul class="creative-stats display-stats social-stats" *ngIf="creative?.isSocial">
											<li class="">
												<h5 class="stats">{{ creative.engagements | number }}</h5>
												<span class="stats-label">ENGAGEMENTS</span>
											</li>
											<li>
												<h5 class="stats">{{ creative.likes | number }}</h5>
												<span class="stats-label">LIKES</span>
											</li>
											<li>
												<h5 class="stats">{{ creative.comments | number }}</h5>
												<span class="stats-label">COMMENTS</span>
											</li>
											<li>
												<h5 class="stats">{{ creative.shares | number }}</h5>
												<span class="stats-label">SHARES</span>
											</li>
											<li>
												<h5 class="stats">{{ creative.saves | number }}</h5>
												<span class="stats-label">SAVES</span>
											</li>
											<li>
												<h5 class="stats">{{ creative.reactions | number }}</h5>
												<span class="stats-label">REACTIONS</span>
											</li>
										</ul>
									</div>

									<div *ngIf="isSocial && creative.isVideoCreative" class="stats-div progress-bar">
										<div class="completion-stats-social">
											<div class="progressbar">
												<div class="primary-color-bg-right-gradient preroll-bg-right-gradient"></div>
											</div>
											<div class="completion-stats-below">
												<div class="stats-label">Started</div>
												<div class="stats-label-views">100% | {{ creative.impressions | formatNumber }} Views</div>
											</div>
										</div>
										<div class="completion-stats-social">
											<div class="progressbar">
												<div
													class="primary-color-bg-right-gradient"
													[ngStyle]="getPercentage(creative.percentRate25)"
												></div>
											</div>
											<div class="completion-stats-below">
												<div class="stats-label">25% Completed</div>
												<div class="stats-label-views">
													{{ creative.percentRate25 }}% | {{ creative.percentValue25 | formatNumber }} Views
												</div>
											</div>
										</div>
										<div class="completion-stats-social">
											<div class="progressbar">
												<div
													class="primary-color-bg-right-gradient"
													[ngStyle]="getPercentage(creative.percentRate50)"
												></div>
											</div>
											<div class="completion-stats-below">
												<div class="stats-label">50% Completed</div>
												<div class="stats-label-views">
													{{ creative.percentRate50 }}% | {{ creative.percentValue50 | formatNumber }} Views
												</div>
											</div>
										</div>
										<div class="completion-stats-social">
											<div class="progressbar">
												<div
													class="primary-color-bg-right-gradient"
													[ngStyle]="getPercentage(creative.percentRate75)"
												></div>
											</div>
											<div class="completion-stats-below">
												<div class="stats-label">75% Completed</div>
												<div class="stats-label-views">
													{{ creative.percentRate75 }}% | {{ creative.percentValue75 | formatNumber }} Views
												</div>
											</div>
										</div>
										<div class="completion-stats-social">
											<div class="progressbar">
												<div
													class="primary-color-bg-right-gradient"
													[ngStyle]="getPercentage(creative.percentRate100)"
												></div>
											</div>
											<div class="completion-stats-below">
												<div class="stats-label">100% Completed</div>
												<div class="stats-label-views">
													{{ creative.percentRate100 }}% | {{ creative.percentValue100 | formatNumber }} Views
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="clear"></div>
							</div>
							<div class="clear"></div>
						</div>
					</ngu-tile>

					<span NguCarouselPrev class="leftRs">
						<i class="fa fa-angle-left" aria-hidden="true"></i>
					</span>
					<span NguCarouselNext class="rightRs">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</span>
				</ngu-carousel>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
<app-modal id="geofence-creative-v4">
	<app-creative-ad-preview
		[creative]="selectedCreative"
		(modalClose)="closeModal('geofence-creative-v4')"
	></app-creative-ad-preview>
	<div class="modal-background"></div>
</app-modal>
